import { Component, inject, input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpersService } from '@/shared/services/helpers.service';
import { finalize } from 'rxjs';
import { SkeletonModule } from 'primeng/skeleton';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { RouterModule } from '@angular/router';
import { GenericProfileService } from '@/shared/services/profile.service';
import { AdminSummaryDto } from '../data-access/admin-dashboard.model';
import { AdminDashboardService } from '../admin-dashboard.service';
import { CardComponent } from '@/shared/ui-components/card/card.component';
import { CurrencyDisplayComponent } from '@/shared/ui-components/currency-display/currency-display.component';
import { Role } from '@/core/models/auth.interface';
@Component({
    standalone: true,
    selector: 'app-a-stats-widget',
    imports: [CommonModule, SkeletonModule, TranslateModule, AngularSvgIconModule, RouterModule, CardComponent, CurrencyDisplayComponent],
    templateUrl: './a-statswidget.html',
})
export class AStatsWidget implements OnInit {
    /** When true, show only deal-related stat cards (hide WM/RM/Client cards). */
    public readonly dealsOnly = input<boolean>(false);
    public readonly disableDealsCardClick = signal<boolean>(false);

    public profileData = signal<AdminSummaryDto | null>(null);
    public profileLoading = signal<boolean>(false);

    private readonly _adminDashboardService = inject(AdminDashboardService);
    private readonly _helperService = inject(HelpersService);
    private readonly _genericProfileService = inject(GenericProfileService);

    public ngOnInit(): void {
        const role = this._genericProfileService.genericProfile()?.role;
        this.disableDealsCardClick.set(role === Role.ADMIN_CLIENT_USERS);
        this.getProfile();
    }

    private getProfile(): void {
        this.profileLoading.set(true);
        this._adminDashboardService
            .getAdminSummary()
            .pipe(finalize(() => this.profileLoading.set(false)))
            .subscribe({
                next: (res) => {
                    this.profileData.set(res);
                },
                error: (err) => {
                    this._helperService.showErrorMessage(err);
                }
            });
    }
}
